module.exports = __webpack_public_path__ + "static/favicon-defe688d37f0983aad327bcb9bdacc41.ico";